<template>
    <div class="auth-container">即将跳转企业微信授权页面...</div>
</template>

<script setup>
import { showDialog } from 'vant';
import { onMounted, nextTick } from "vue";
import { isWeCom, buildWeComUserinfoAuthUrl } from "@/utils/wecomcon";
import router from '@/router'

const corpId = "ww3de420d40f59739c";
const agentId = "1000002";
// 检查是否登录
onMounted(async () => {
    console.log("登录");
    // 等待页面真正渲染完成
    await nextTick();
    // 再异步执行弹框，确保不阻塞
    setTimeout(() => {
        if (!isWeCom()) {
            showDialog({
                message: '请在企业微信中打开此页面',
                theme: 'round-button',
                confirmButtonColor: '#DCBB89',
            }).then(() => {
                
            });
            return;
        }

        // 企业微信环境 → 构造授权链接并跳转
        const { protocol, host } = window.location;
        const redirectUrl = `${protocol}//${host}/callback`;

        const authUrl = buildWeComUserinfoAuthUrl({
            corpId,
            agentId,
            redirectUrl,
        });

        window.location.href = authUrl;
    }, 0);
});
</script>

<style scoped>
.auth-container {
    text-align: center;
    padding: 20px;
    font-size: 20px;
    font-weight: 500;
    color: #654317;
    font-family: 'PingFang SC-Semibold';
}
</style>
